module.exports = __webpack_public_path__ + "static/img/addconsignee.fc536a4.svg";